import { useEffectiveOrgName } from '@/stores/useOrgStore';

// Read-only chip showing the active org's name. Hidden when we don't have a
// name yet (kiosk, /me failed, or org list still loading for verne admins).
export function OrgBadge() {
  const name = useEffectiveOrgName();
  if (!name) return null;
  const short = name.length > 22 ? `${name.slice(0, 20)}…` : name;
  return (
    <div
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold text-foreground select-none"
      title={name}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0 text-muted">
        <path d="M3 21h18" />
        <path d="M5 21V7l7-4 7 4v14" />
        <path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01M9 17h.01M15 17h.01" />
      </svg>
      {short}
    </div>
  );
}
